import { lazy } from 'react'
import { redirect } from 'react-router-dom'

import { JobLevelRateDetailsDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { RoleDetailsHeader } from 'modules/project_management/components/headers/RoleDetailsHeader'

const JobsAndRatesRootPage = lazy(
  () => import('modules/project_management/pages/JobsAndRatesRootPage/index')
)
const JobsAndRatesListPage = lazy(
  () => import('modules/project_management/pages/JobsAndRatesPage/index')
)
const RoleDetailsPage = lazy(
  () => import('modules/project_management/pages/JobsAndRatesPage/RoleDetailsPage/index')
)

export const jobsAndRatesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.projects.jobsAndRates.path,
      element: <JobsAndRatesRootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('project_management.meta_data.jobs_and_rates.title'),
        }),
      },
      children: [
        {
          index: true,
          loader: () => redirect(navigation.projects.jobsAndRates.list.path),
        },
        {
          path: navigation.projects.jobsAndRates.list.path,
          element: <JobsAndRatesListPage />,
        },
        {
          path: navigation.projects.jobsAndRates.rateId.path,
          element: <RoleDetailsPage />,
          handle: {
            resource: true,
            meta: ({ params, watchQuery }) => {
              return watchQuery({
                query: JobLevelRateDetailsDocument,
                fetchPolicy: 'cache-first',
                variables: {
                  id: Number(params['rateId']),
                },
              }).map(({ data }) => {
                const { rate } = data.projectManagement
                const canManageRate = !!data.projectManagement._policies.rateManage.can

                const resource = rate?.resource

                const roleName =
                  resource && 'ancestor' in resource
                    ? resource.ancestor?.name
                    : resource && 'role' in resource
                    ? resource.role?.name
                    : undefined

                const levelName =
                  resource && 'name' in resource
                    ? resource.name
                    : resource && 'levelName' in resource
                    ? resource.levelName
                    : undefined

                const resourceId = resource && 'id' in resource ? resource.id : undefined

                if (!canManageRate || !rate || !roleName || !levelName || !resourceId) return

                const {
                  billingRateCents,
                  currency,
                  chargingCostCents,
                  profitabilityPercentageCents,
                  resourceType,
                } = rate
                return {
                  title: roleName,
                  headerComponent: (
                    <RoleDetailsHeader
                      billRate={billingRateCents}
                      canManageRate={canManageRate}
                      currency={currency}
                      levelName={levelName}
                      maxCostRate={chargingCostCents}
                      minProfitMargin={profitabilityPercentageCents}
                      roleName={roleName}
                      resourceId={resourceId}
                      resourceType={resourceType}
                    />
                  ),
                }
              })
            },
          },
        },
      ],
    },
  ]
}
